import type { IconSvgObject } from './types';

const Triangle02Icon: IconSvgObject = [
  ["path", { d: "M5 9.50769L8.5 12.0077", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19 9.50769L15.5 12.0077", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 7.50768L11.1362 2.98844C11.5221 2.32693 12.4779 2.32693 12.8638 2.98844L15.5 7.50768M5 13.5077L2.72361 18.0605C2.39116 18.7254 2.87465 19.5077 3.61804 19.5077H8.5M19 13.5077L21.2764 18.0605C21.6088 18.7254 21.1253 19.5077 20.382 19.5077H15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M12 17.5077V21.5077", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Triangle02Icon;
